'use strict';

var _get = require('babel-runtime/helpers/get')['default'];

var _inherits = require('babel-runtime/helpers/inherits')['default'];

var _classCallCheck = require('babel-runtime/helpers/class-call-check')['default'];

var _createClass = require('babel-runtime/helpers/create-class')['default'];

var _Object$keys = require('babel-runtime/core-js/object/keys')['default'];

var _interopRequireDefault = require('babel-runtime/helpers/interop-require-default')['default'];

Object.defineProperty(exports, '__esModule', {
    value: true
});

var _is = require('is');

var _is2 = _interopRequireDefault(_is);

var _init = require('./init');

var InvalidResponseCode = (function (_Error) {
    _inherits(InvalidResponseCode, _Error);

    function InvalidResponseCode(statusCode, statusText, responseText) {
        _classCallCheck(this, InvalidResponseCode);

        _get(Object.getPrototypeOf(InvalidResponseCode.prototype), 'constructor', this).call(this, 'InvalidResponseCode ' + statusCode + ': ' + statusText);

        this.statusCode = statusCode;
        this.statusText = statusText;
        this.responseText = responseText;
    }

    return InvalidResponseCode;
})(Error);

exports.InvalidResponseCode = InvalidResponseCode;

var ValidationError = (function (_InvalidResponseCode) {
    _inherits(ValidationError, _InvalidResponseCode);

    function ValidationError(err) {
        _classCallCheck(this, ValidationError);

        _get(Object.getPrototypeOf(ValidationError.prototype), 'constructor', this).call(this, err.statusCode, err.statusText, err.responseText);

        this.errors = {};
        this.nonFieldErrors = null;

        this.__parseErrors(err.responseText);
    }

    _createClass(ValidationError, [{
        key: 'getFieldError',
        value: function getFieldError(fieldName, allowNonFields) {
            if (this.errors[fieldName] || allowNonFields && this.nonFieldErrors) {
                return this.errors[fieldName] || this.nonFieldErrors;
            }

            return null;
        }
    }, {
        key: '__parseErrors',
        value: function __parseErrors(errorText) {
            var handler = (0, _init.getConfig)('parseErrors') || ValidationError.defaultParseErrors;

            var result = handler(errorText);

            this.nonFieldErrors = result[0];
            this.errors = result[1];
        }
    }], [{
        key: 'defaultParseErrors',
        value: function defaultParseErrors(errorText) {
            if (_is2['default'].string(errorText)) {
                errorText = JSON.parse(errorText);
            }

            var resNonField = null;
            var resErrors = {};

            var errors = typeof errorText.errors === "undefined" ? errorText : errorText.errors;
            _Object$keys(errors).forEach(function (key) {
                if (key === 'non_field_errors') {
                    resNonField = ValidationError.prepareError(errors[key]);
                } else {
                    resErrors[key] = ValidationError.prepareError(errors[key]);
                }
            });

            return [resNonField, resErrors];
        }
    }, {
        key: 'prepareError',
        value: function prepareError(err) {
            if (_is2['default'].string(err)) {
                return err;
            } else if (_is2['default'].array(err)) {
                return err.join(', ');
            } else if (_is2['default'].object(err)) {
                // Note: This is a bad way to return perField errors
                return JSON.stringify(err);
            } else {
                return err + '';
            }
        }
    }]);

    return ValidationError;
})(InvalidResponseCode);

exports.ValidationError = ValidationError;


/*****************
 ** WEBPACK FOOTER
 ** ./~/tg-resources/dist/errors.js
 ** module id = 238
 ** module chunks = 1
 **/